module.exports = __webpack_public_path__ + "static/media/Boho-StylePicker.936319ae.jpg";